'use client';

import type { ChartCallbackFunction, Options } from 'highcharts/highcharts';
import {
  forwardRef,
  type HTMLProps,
  memo,
  type ReactElement,
  useEffect,
} from 'react';

interface HighchartsReactProps {
  options: Options;
  callback?: ChartCallbackFunction;
  allowChartUpdate?: boolean;
  immutable?: boolean;
  updateArgs?: [boolean, boolean];
  containerProps?: HTMLProps<HTMLElement>;
}

declare const Highcharts: {
  chart: (
    container: string | HTMLElement,
    options: Options,
    callback?: ChartCallbackFunction,
  ) => void;
};

export const HighchartsReact = memo(
  forwardRef(function HighchartsReact(
    props: HighchartsReactProps,
  ): ReactElement {
    useEffect(() => {
      Highcharts.chart('highcharts-container', props.options, props.callback);
    }, [props.options, props.callback]);

    // Create container for the chart
    return <div id="highcharts-container" style={{ height: 500 }} />;
  }),
);

export default HighchartsReact;
